export const setStoresNameByUserId = (stores, userId): void => {
  stores.forEach(([store, storageKey]) => {
    // rename the store
    store?.persist.setOptions({
      name: `${storageKey}-${userId}` as string,
    })
    // rehydrate the store
    store?.persist.rehydrate()
    // remove the default index
    localStorage.removeItem(storageKey)
  })
}
